const JsonStringify = (data: any) => {
    if (_.isNil(data)) {
        return;
    }
    return JSON.stringify(data, null ,2);
}
const JsonParse = (data: any) => {
    if (_.isNil(data)) {
        return;
    }
    return JSON.parse(data);
}
export {
    JsonStringify,
    JsonParse
}